(() => {
  const emit = (name, detail) => {
    window.dispatchEvent(new CustomEvent(name, { detail }));
    try {
      window.Shopify?.analytics?.publishCustomEvent?.(
        `field_signal:${name.replace('fieldsignal:', '')}`,
        detail
      );
    } catch (_) {
      // Analytics is optional and must not affect purchase behavior.
    }
  };

  function selectedTab(landing) {
    return landing.querySelector('[role="tab"][aria-selected="true"]');
  }

  function setStickyFromPanel(landing, version) {
    const offer = landing.querySelector('[data-fs-ad-offer-selected]');
    const duo = offer?.dataset.fscPairOption === 'duo';
    const form = offer?.closest('[data-fsc-pair-form]') || landing.querySelector('[data-fsc-pair-form]');
    const paid = !duo && Boolean(form?.querySelector('[data-fsc-pair-paid-protection]')?.checked);
    let amount = 'Unavailable';
    try {
      const config = JSON.parse(form?.querySelector('[data-fsc-pair-config]')?.textContent || '{}');
      amount = `$${(window.FieldSignalPairOfferCore.total(config, duo ? 'duo' : 'single', paid) / 100).toFixed(2)}`;
    } catch (_) { /* Main offer controls display the validation message. */ }
    const versionNode = landing.querySelector('[data-fs-pdp-sticky-version]');
    const priceNode = landing.querySelector('[data-fs-pdp-sticky-price]');
    const planNode = landing.querySelector('[data-fs-pdp-sticky-plan]');
    if (versionNode) versionNode.textContent = duo ? '2 Pro pairs' : '1 Pro pair';
    if (priceNode) priceNode.textContent = amount;
    if (planNode) planNode.textContent = duo ? 'Free 2-year protection for both' : paid ? '2-year protection added' : 'No added protection plan';
  }

  function syncSticky(landing) {
    const version = selectedTab(landing)?.dataset.fsAdVersion || 'pro';
    setStickyFromPanel(landing, version);
  }

  function setupGallery(landing) {
    landing.addEventListener('click', (event) => {
      const thumb = event.target.closest('[data-fs-pdp-gallery-thumb]');
      if (!thumb || !landing.contains(thumb)) return;

      const gallery = thumb.closest('.fs-pdp-gallery');
      const source = thumb.dataset.fsPdpGallerySrc;
      if (!gallery || !source) return;
      // The main gallery controller owns lead, zoom, thumbnail and count state.
      // Keep this listener for analytics only so the two cannot drift apart.
      emit('fieldsignal:gallery_interaction', {
        image: source,
        product: gallery.dataset.fsAdVersion || '',
      });
    });
  }

  function setupSticky(landing) {
    const sticky = landing.querySelector('[data-fs-pdp-sticky]');
    const buy = landing.querySelector('.fs-pdp-stage__purchase');
    if (!sticky || !buy) return;
    const pageWrapper = document.querySelector('.page-wrapper');

    const updateVisibility = () => {
      const desktopScroller =
        window.matchMedia('(min-width: 990px)').matches && pageWrapper;
      const scrollTop = desktopScroller ? pageWrapper.scrollTop : window.scrollY;
      const scrollerTop = desktopScroller ? pageWrapper.getBoundingClientRect().top : 0;
      const buyTop = buy.getBoundingClientRect().top - scrollerTop + scrollTop;
      const compactViewport = window.matchMedia('(max-width: 749px)').matches;
      const threshold = compactViewport
        ? Math.max(0, buyTop - window.innerHeight * 0.25)
        : buyTop + 260;
      sticky.classList.toggle('is-visible', scrollTop > threshold);
    };

    window.addEventListener('scroll', updateVisibility, { passive: true });
    pageWrapper?.addEventListener('scroll', updateVisibility, { passive: true });
    window.addEventListener('resize', updateVisibility, { passive: true });
    sticky.querySelector('[data-fs-pdp-sticky-submit]')?.addEventListener('click', () => {
      const version = selectedTab(landing)?.dataset.fsAdVersion || 'pro';
      const panel = landing.querySelector(
        `.fs-pdp-purchase-panel[data-fs-ad-version="${version}"]`
      );
      const form = panel?.querySelector('[data-fsc-pair-form]');
      if (!form) return;
      if (form.getAttribute('aria-busy') === 'true') return;
      const submitter = form.querySelector('[type="submit"]');
      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit(submitter || undefined);
      } else {
        submitter?.click();
      }
    });
    updateVisibility();
  }

  function setupInteractionSync(landing) {
    document.addEventListener('fieldsignal:version_change', (event) => {
      if (!event.detail?.version) return;
      window.setTimeout(() => syncSticky(landing), 0);
    });

    landing.addEventListener('click', (event) => {
      const control = event.target.closest(
        '[data-fs-ad-offer], [role="tab"][data-fs-ad-version]'
      );
      if (!control || !landing.contains(control)) return;
      window.setTimeout(() => syncSticky(landing), 0);
    });

    landing.addEventListener('change', (event) => {
      if (!event.target.closest('[data-fsc-pair-paid-protection], [data-fs-pdp-color]')) return;
      window.setTimeout(() => syncSticky(landing), 0);
    });

    landing.querySelectorAll('details').forEach((detail) => {
      detail.addEventListener('toggle', () => {
        if (!detail.open) return;
        emit('fieldsignal:faq_toggle', {
          question: detail.querySelector('summary')?.textContent?.trim() || '',
        });
      });
    });

  }

  function initializeLanding(landing) {
    if (landing.dataset.fsPaidPdpInitialized === 'true') return;
    landing.dataset.fsPaidPdpInitialized = 'true';
    document.body.classList.add('fs-paid-pdp-active');
    setupGallery(landing);
    setupSticky(landing);
    setupInteractionSync(landing);
    syncSticky(landing);
  }

  function initialize() {
    document.querySelectorAll('[data-fsc-pair-pdp]').forEach(initializeLanding);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
